import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/tetris-groups'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  create: NoParamEndpointConstructor
  remove: SingleParamEndpointConstructor
  update: SingleParamEndpointConstructor
}

export const tetrisGroupsEndpoints: Endpoints = {
  getAll: () => baseUrl,
  create: () => baseUrl,
  remove: (id) => `${baseUrl}/${id}`,
  update: (id) => `${baseUrl}/${id}`,
}
